import { render, staticRenderFns } from "./operational-permit-list.vue?vue&type=template&id=54448b9b&scoped=true&"
import script from "./operational-permit-list.vue?vue&type=script&lang=js&"
export * from "./operational-permit-list.vue?vue&type=script&lang=js&"
import style0 from "./operational-permit-list.vue?vue&type=style&index=0&id=54448b9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54448b9b",
  null
  
)

export default component.exports